import React from 'react'
import { useTheme, useMediaQuery } from '@mui/material'

interface BreakpointContextType {
  isExtraSmall: boolean
  isSmall: boolean
  isNotSmall: boolean
  isMedium: boolean
  isNotMedium: boolean
  down429: boolean
  down450: boolean
  down451: boolean
  down480: boolean
  down575: boolean
  down600: boolean
  down767: boolean
  down770: boolean
  down800: boolean
  down840: boolean
  down950: boolean
  down990: boolean
  down1300: boolean
  down1025: boolean
  between480_768: boolean
  up450: boolean
  up600: boolean
  up767: boolean
  up770: boolean
  up800: boolean
  up840: boolean
  up990: boolean
  up1024: boolean
}

const BreakpointContext = React.createContext<BreakpointContextType>(null)

const BreakpointProvider = ({ children }) => {
  const theme = useTheme()

  // Standard breakpoints
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const isSmall = useMediaQuery(theme.breakpoints.down('md'))
  const isNotSmall = useMediaQuery(theme.breakpoints.up('sm'))
  const isMedium = useMediaQuery(theme.breakpoints.down('lg'))
  const isNotMedium = useMediaQuery(theme.breakpoints.up('md'))

  // Non-standard breakpoints
  const down429 = useMediaQuery(theme.breakpoints.down(429))
  const down450 = useMediaQuery(theme.breakpoints.down(450))
  const down451 = useMediaQuery(theme.breakpoints.down(451))
  const down480 = useMediaQuery(theme.breakpoints.down(480))
  const down575 = useMediaQuery(theme.breakpoints.down(575))
  const down600 = useMediaQuery(theme.breakpoints.down(600))
  const down767 = useMediaQuery(theme.breakpoints.down(767))
  const down770 = useMediaQuery(theme.breakpoints.down(770))
  const down800 = useMediaQuery(theme.breakpoints.down(800))
  const down840 = useMediaQuery(theme.breakpoints.down(840))
  const down950 = useMediaQuery(theme.breakpoints.down(950))
  const down990 = useMediaQuery(theme.breakpoints.down(990))
  const down1300 = useMediaQuery(theme.breakpoints.down(1300))
  const down1025 = useMediaQuery(theme.breakpoints.down(1025))

  const between480_768 = useMediaQuery(theme.breakpoints.between(480, 768))

  const up450 = useMediaQuery(theme.breakpoints.up(450))
  const up600 = useMediaQuery(theme.breakpoints.up(600))
  const up767 = useMediaQuery(theme.breakpoints.up(767))
  const up770 = useMediaQuery(theme.breakpoints.up(770))
  const up800 = useMediaQuery(theme.breakpoints.up(800))
  const up840 = useMediaQuery(theme.breakpoints.up(840))
  const up990 = useMediaQuery(theme.breakpoints.up(990))
  const up1024 = useMediaQuery(theme.breakpoints.up(1024))

  return (
    <BreakpointContext.Provider
      value={{
        isExtraSmall,
        isSmall,
        isNotSmall,
        isMedium,
        isNotMedium,

        down429,
        down450,
        down451,
        down480,
        down575,
        down600,
        down767,
        down770,
        down800,
        down840,
        down950,
        down990,
        down1300,
        down1025,

        between480_768,

        up450,
        up600,
        up767,
        up770,
        up800,
        up840,
        up990,
        up1024
      }}
    >
      {children}
    </BreakpointContext.Provider>
  )
}

export default BreakpointProvider

export const useBreakpoint = () => React.useContext(BreakpointContext)
